import {Entity} from '../base/entity';

export class Stockroom extends Entity {

  public static readonly TABLENAME = 'stockroom';

  public static readonly ID = 'id';
  public static readonly OWN = 'own';
  public static readonly STOCKROOM_TYPE_ID = 'stockroom_type_id';
  public static readonly NAME = 'name';
  public static readonly CODE = 'code';
  public static readonly ACCOUNT = 'account';
  public static readonly PRICELIST_ID = 'pricelist_id';
  public static readonly LOCATION = 'location';
  public static readonly LOCATION_REQUIRED = 'location_required';
  public static readonly COST_LOCATION_ID = 'cost_location_id';
  public static readonly STOCK_METHOD = 'stock_method';
  public static readonly INVENTORY_ACCOUNTING = 'inventory_accounting';
  public static readonly COMPANY_ID = 'company_id';
  public static readonly AUTOMATIC_RECEPTION = 'automatic_reception';
  public static readonly VAT = 'vat';
  public static readonly E_UPRAVA = 'e_uprava';
  public static readonly IS_ACTIVE = 'is_active';

  public static readonly ADDRESS = 'address';
  public static readonly CITY_ID = 'city_id';

  public static readonly CREATED_AT = 'created_at';
  public static readonly UPDATED_AT = 'updated_at';
  public static readonly DELETED_AT = 'deleted_at';

  id: string;
  own: boolean;
  stockroomTypeId: number;
  name: string;
  code: string;
  account: string;
  pricelistId: string;
  location: boolean;
  locationRequired: boolean;
  costLocationId: boolean;
  stockMethod: string;
  inventoryAccounting: number;
  companyId: string;
  stockroomTypeName: string;
  stockroomAccount: string;
  stockroomPriceType: string;
  automatiReception: boolean;
  vat: boolean;
  eUprava: boolean;
  isActive: boolean;

  address: string;
  cityId: number;

  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;

}
